import { Link } from "react-router-dom";
import moment from "moment";

const formatCurrency = (value) => {
  if (value == null) return "—";
  return "$" + value.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

const formatTripType = (tripType) => {
  switch (tripType) {
    case 1:
      return "One Way";
    case 2:
      return "Round Trip";
    default:
      return "—";
  }
};

const formatPricingMethod = (method) => {
  switch (method) {
    case "ow":
      return "OW Pricing";
    case "ptp2":
      return "PTP2 Pricing";
    case "otg":
      return "OTG Pricing";
    case "drt":
      return "DRT Pricing";
    default:
      return method || "—";
  }
};

const formatSelectionOrigin = (origin) => {
  switch (origin) {
    case "hqCalculator":
      return "HQ Calculator";
    case "hqSingleCTFPage":
      return "HQ CTF Page";
    case "iosApp":
      return "iOS App";
    default:
      return origin || "—";
  }
};

const formatEstimateOrigin = (origin) => {
  switch (origin) {
    case "flightDeckInternal":
      return "HQ - Internal";
    case "flightDeckExternal":
      return "HQ - External";
    case "liveAPI":
      return "Live API";
    case "ios":
      return "iOS App";
    case "outsideOrg":
      return "Outside Org";
    case "atc":
      return "ATC";
    case "testEstimate":
      return "Test Estimate";
    default:
      return origin || "—";
  }
};

const columns = [
  {
    name: "View",
    sortable: false,
    cell: (row) => {
      return (
        <Link
          to={`/click-to-fly/results/${row._id}`}
          className="base-button evo-blue icon-button icon-button-small"
          title="View Result"
        >
          <span className="material-icons">visibility</span>
        </Link>
      );
    },
    width: "70px",
  },
  {
    name: "Route",
    sortable: false,
    width: "180px",
    cell: (row) => {
      const depCode =
        row.routeId?.departureAirport?.code ||
        row.estimateId?.departureAirportCode ||
        "?";
      const arrCode =
        row.routeId?.arrivalAirport?.code ||
        row.estimateId?.arrivalAirportCode ||
        "?";
      return (
        <span className="route-display">
          <strong>{depCode}</strong> → <strong>{arrCode}</strong>
        </span>
      );
    },
  },
  {
    name: "Trip Type",
    selector: "tripType",
    sortable: true,
    width: "120px",
    cell: (row) => formatTripType(row.tripType),
  },
  {
    name: "Lowest Price",
    selector: "lowestStartingPrice",
    sortable: true,
    width: "130px",
    cell: (row) => {
      return (
        <span className="price-display">
          {formatCurrency(row.lowestStartingPrice)}
        </span>
      );
    },
  },
  {
    name: "Aircraft",
    sortable: false,
    width: "150px",
    cell: (row) => {
      return row.lowestStartingAircraftTypeId?.name || "—";
    },
  },
  {
    name: "Pricing Method",
    selector: "lowestPriceMethod",
    sortable: true,
    width: "140px",
    cell: (row) => formatPricingMethod(row.lowestPriceMethod),
  },
  {
    name: "Distance",
    selector: "distance",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.distance ? `${row.distance.toLocaleString()} mi` : "—";
    },
  },
  {
    name: "Aircraft Options",
    sortable: false,
    width: "130px",
    cell: (row) => {
      const count = row.aircraftOptions?.length || 0;
      return `${count} option${count !== 1 ? "s" : ""}`;
    },
  },
  {
    name: "Preferences",
    sortable: false,
    width: "120px",
    cell: (row) => {
      if (!row.userSelection || !row.userSelection.selectedAt) {
        return "—";
      }
      return (
        <span
          className="badge bg-success"
          title={`Saved via ${formatSelectionOrigin(row.userSelection.selectionOrigin)}`}
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            backgroundColor: "#28a745",
            color: "white",
          }}
        >
          Saved
        </span>
      );
    },
  },
  {
    name: "WiFi",
    sortable: false,
    width: "80px",
    cell: (row) => {
      if (!row.userSelection) {
        return "—";
      }
      if (row.userSelection.selectedWifiEnabled) {
        return (
          <span
            className="badge"
            title="WiFi Included"
            style={{
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              backgroundColor: "#17a2b8",
              color: "white",
            }}
          >
            Yes
          </span>
        );
      }
      return "—";
    },
  },
  {
    name: "Departure Date",
    sortable: false,
    width: "130px",
    cell: (row) => {
      const date = row.estimateId?.departureDate;
      if (!date) return "—";
      return moment(date).format("MM/DD/YYYY");
    },
  },
  {
    name: "Origin",
    sortable: false,
    width: "120px",
    cell: (row) => formatEstimateOrigin(row.estimateId?.origin),
  },
  {
    name: "Created",
    selector: "createdAt",
    sortable: true,
    width: "170px",
    cell: (row) => {
      return moment(row.createdAt).format("MMM D, YYYY h:mm A");
    },
  },
];

export default columns;

